"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.step = void 0;
const tslib_1 = require("tslib");
require("../../../../TdWebtoolkitControls/controls/Wizard/Wizard");
const Utilities_1 = require("../../../../TdWebtoolkitControls/javascript/Utilities");
require("./stepNames");
const stepNames_1 = require("./stepNames");
const endImageUrl = require("../wizardSteps/end.png");
exports.step = {
    name: stepNames_1.WizardStepNames[stepNames_1.WizardStepNames.end],
    run: ($this) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        let pathStorage = $this.synWizard("getPathStorage");
        let globalStorage = $this.synWizard("getGlobalStorage");
        let checklistId = pathStorage["checklistId"];
        // Disable all previous steps
        globalStorage["finished"] = true;
        yield $this.synWizard("notifyGlobalStorageChanged");
        let submitstate = Utilities_1.synUtil.Configs.getValueMandatory("visitormanagement.submitstate");
        let finishedstate = Utilities_1.synUtil.Configs.getValueMandatory("visitormanagement.finishedstate");
        if (submitstate && finishedstate) {
            try {
                //Change status to create pdf
                let instance = yield Utilities_1.synUtil.getInstanceAsync(checklistId);
                instance.items["cgdocument.stateid"].value = submitstate;
                try {
                    yield Utilities_1.synUtil.getAJAXDataAsync({
                        method: "POST",
                        url: Utilities_1.synUtil.getWSUrl("InstanceSave"),
                        requestData: {
                            instance: JSON.stringify(instance.toJSON())
                        },
                    });
                }
                catch (error) {
                    Utilities_1.synUtil.Notifications.error(error);
                }
                let $contentDiv = $this.synWizard("getStepContentDiv").addClass("end");
                // Surrounding div
                let $wrapper = $("<div class='visitorManagementEndDiv'></div>");
                $contentDiv.append($wrapper);
                // Text
                const $defHtml = $("<div class='endMsgWrap'>\
                    <div class='waitPrinterMsg'></div>\
                    <div class='endMsg'></div>\
                    <div class='importantMsg'></div>\
                </div>");
                const uiLangId = Utilities_1.synUtil.UserInfo.getUserInfo().UILanguageId;
                if (uiLangId === "49") {
                    $defHtml.children(".waitPrinterMsg").text("Bitte auf Ausdruck warten...");
                    $defHtml.children(".endMsg").html("Vielen Dank für die Aufmerksamkeit.<br />Sie haben die Standortunterweisung erfolgreich absolviert.<br />Bitte zeigen Sie den Besucherschein am Empfang.");
                    $defHtml.children(".importantMsg").text("Der Besucherschein ist zu unterzeichnen und mitzuführen.");
                }
                else {
                    $defHtml.children(".waitPrinterMsg").text("Please wait for the printout...");
                    $defHtml.children(".endMsg").html("Thank you for your attention.<br />You have passed the site instructions.<br />Please show the visitor's pass at the reception.");
                    $defHtml.children(".importantMsg").text("The visitor's pass needs to be signed and carried along for the visit.");
                }
                let text = "";
                if (pathStorage["isTerminal"] === true)
                    text = Utilities_1.synUtil.Strings.getValue("visitormanagement.enddescriptionterminal", "");
                else
                    text = Utilities_1.synUtil.Strings.getValue("visitormanagement.enddescription", "");
                $("<img class='endImg'>")
                    .attr({
                    alt: "printer",
                    src: endImageUrl
                })
                    .appendTo($wrapper);
                if (text === "")
                    $wrapper.append($defHtml[0].outerHTML);
                else
                    $wrapper.append(text);
                //Copy pdf to filecache
                let filecacheData = yield Utilities_1.synUtil.getAJAXDataAsync({
                    url: Utilities_1.synUtil.getWSUrl("ContentInstanceCopyToFilecache") + checklistId + "/2",
                });
                //Change instance status to block further access
                let instance2 = yield Utilities_1.synUtil.getInstanceAsync(checklistId);
                instance2.items["cgdocument.stateid"].value = finishedstate;
                try {
                    yield Utilities_1.synUtil.getAJAXDataAsync({
                        method: "POST",
                        url: Utilities_1.synUtil.getWSUrl("InstanceSave"),
                        requestData: {
                            instance: JSON.stringify(instance2.toJSON())
                        },
                    });
                }
                catch (error) {
                    Utilities_1.synUtil.Notifications.error(error);
                }
                let visitorManagementTerminalPrintMethod = Utilities_1.synUtil.Configs.getValue("webtoolkit.visitormanagementprintmethod", "workspace");
                // Deliver pdf
                if (pathStorage["isTerminal"] !== true) {
                    // Download button if not terminal
                    let $downloadButton = $("<button type='button' class='btn k-button download' content='application/pdf'><i class='fa fa-download k-button-icon'></i>" + Utilities_1.synUtil.Strings.getValue('download') + "</button>");
                    let filecacheUrl = "WSProxy.axd?cache=FileCache/" + filecacheData.containerId + "/" + filecacheData.fileId;
                    $downloadButton.off("click").on("click", () => {
                        window.open(filecacheUrl);
                        $this.synWizard("enableNextButton");
                    });
                    $wrapper.append($downloadButton);
                }
                else if (pathStorage["isTerminal"] === true && visitorManagementTerminalPrintMethod === "webserver") {
                    // Silent print if terminal
                    const locationId = sessionStorage.getItem("visitorManagement.locationId") || undefined;
                    try {
                        yield Utilities_1.synUtil.getAJAXData({
                            method: "POST",
                            requestData: {
                                id: instance.id.value,
                                locationId
                            },
                            url: Utilities_1.synUtil.getWSUrl("IntegrationVisitorManagementPrintPDF"),
                            done() {
                                $this.synWizard("enableNextButton");
                            },
                            fail(error) {
                                Utilities_1.synUtil.Notifications.error(kendo.format(error.responseJSON.ErrorMessage));
                            }
                        });
                    }
                    catch (error) {
                        Utilities_1.synUtil.Notifications.error(error);
                    }
                }
                else {
                    // Silent print from workspace
                    // locationId is NOT supported in this case
                    let instanceId = checklistId.split("|")[0];
                    let workspaceUrl = "synerisws" + instanceId + "://common/printpdf/" + instanceId + "/" + filecacheData.containerId + "/false";
                    Utilities_1.synUtil.openWorkspace(workspaceUrl);
                    $this.synWizard("enableNextButton");
                }
            }
            catch (error) {
                $.error(error);
            }
        }
    }),
    hideBtnCancel: true,
    hideBtnPrevious: true
};
